export class CustomerCrmModel{
    CustomerCode: string;
    CustomerName: string;
    SalesOrg: string;
    DistChannel: string;
    Division: string;
    CrmTxt: string;
}


// WEBPACK FOOTER //
// ./src/models/customer/customercrm.model.ts